import i18n from '@/i18n'
import { gm } from './gm'

const jsjky = () => import('@/components/firms/jsjky.vue')
const jhhx = () => import('@/components/firms/jhhx.vue')
const dfyh = () => import('@/components/firms/dfyh.vue')
const jsqt = () => import('@/components/firms/jsqt.vue')
const shsk = () => import('@/components/firms/shsk.vue')
const hdjs = () => import('@/components/firms/hdjs.vue')
const yajs = () => import('@/components/firms/yajs.vue')
const jgs = () => import('@/components/firms/jgs.vue')
const zyf = () => import('@/components/firms/zyf.vue')
const yjjt = () => import('@/components/firms/yjjt.vue')
const jsjs = () => import('@/components/firms/jsjs.vue')
const btkj = () => import('@/components/firms/btkj.vue')
const kld = () => import('@/components/firms/kld.vue')
const jlkj = () => import('@/components/firms/jlkj.vue')
export const groupMap = {
    f0: jsjky, // 姹熻嫃寤虹闄?1
    f1: jhhx, //姹熸捣鏉惂 1
    f2: dfyh, //涓滄柟闆ㄨ櫣1
    f3: jsqt,    //姹熻嫃鎿庡ぉ宸ヤ笟浜掕仈缃戞湁闄愬叕鍙哥畝浠?1
    f4: shsk, //涓婃捣鍦ｅ 1
    f5: hdjs, //瀹忓ぇ寤鸿 1
    f6: yajs,// 姹熻嫃瀹滃畨寤鸿 1
    f7: jgs, // 浣冲浐澹?1
    f8: zyf, // 涓嚎涓?1
    f9: yjjt, // 姹熻嫃鎵缓 1
    f10: jsjs, // 姹熻嫃閿︿笂 1
    f11: btkj, // 鍗椾含璐濆攼銆€锛?    f12: jlkj, // 涔呯摯绉戞妧
    f13: kld, // 涔呯摯绉戞妧
    f14: () => import('@/components/firms/26du/index.vue'),
    f15: () => import('@/components/firms/gdw/index.vue'),
    f16: () => import('@/components/firms/gwjs/index.vue'),
    f17: () => import('@/components/firms/jsjzzyxy/index.vue'),
    f18: () => import('@/components/firms/jslx/index.vue'),
    f19: () => import('@/components/firms/jpyl/index.vue'),
    f20: () => import('@/components/firms/elematic/index.vue'),
    f21: () => import('@/components/firms/dv/index.vue'),
    f22: () => import('@/components/firms/bjaq/index.vue'),
    f23: () => import('@/components/firms/hbok/index.vue'),
    f24: () => import('@/components/firms/kdgj/index.vue'),
    f25: () => import('@/components/firms/kldtl/index.vue'),
    f26: () => import('@/components/firms/lczg/index.vue'),
    f27: () => import('@/components/firms/kbd/index.vue'),
    f28: () => import('@/components/firms/meb/index.vue'),
    f29: () => import('@/components/firms/bhbl/index.vue'),
    f30: () => import('@/components/firms/cztj/index.vue'),
    f31: () => import('@/components/firms/dlly/index.vue'),
    f32: () => import('@/components/firms/jssw/index.vue'),
    f33: () => import('@/components/firms/jywy/index.vue'),
    f34: () => import('@/components/firms/jykj/index.vue'),
    f35: () => import('@/components/firms/jbh/index.vue'),
    f36: () => import('@/components/firms/jlz/index.vue'),
    f37: () => import('@/components/firms/klsk/index.vue'),
    f38: () => import('@/components/firms/nthy/index.vue'),
    f39: () => import('@/components/firms/wxlr/index.vue'),
    f40: () => import('@/components/firms/wxxzh/index.vue'),
    f41: () => import('@/components/firms/nths/index.vue'),
    f42: () => import('@/components/firms/jssx/index.vue'),
    f43: () => import('@/components/firms/hxnj/index.vue'),
    f44: () => import('@/components/firms/jsjr/index.vue'),
    f45: () => import('@/components/firms/sjzxy/index.vue'),
    f46: () => import('@/components/firms/sghjt/index.vue'),
    f47: () => import('@/components/firms/dgsp/index.vue'),
    f48: () => import('@/components/firms/szjz/index.vue'),
    f49: () => import('@/components/firms/szxy/index.vue'),
    f50: () => import('@/components/firms/szylsj/index.vue'),
    f51: () => import('@/components/firms/tsbq/index.vue'),
    f52: () => import('@/components/firms/z52/index.vue'),
    f53: () => import('@/components/firms/z53/index.vue'),
    f54: () => import('@/components/firms/z54/index.vue'),
    f55: () => import('@/components/firms/z55/index.vue'),
    f56: () => import('@/components/firms/z56/index.vue'),
    f57: () => import('@/components/firms/z57/index.vue'),
    f58: () => import('@/components/firms/z58/index.vue'),
    f59: () => import('@/components/firms/z59/index.vue'),
    f60: () => import('@/components/firms/z60/index.vue'),
    f61: () => import('@/components/firms/z61/index.vue'),
    f62: () => import('@/components/firms/z62/index.vue'),
    f63: () => import('@/components/firms/z63/index.vue'),
    f64: () => import('@/components/firms/z64/index.vue'),
    f65: () => import('@/components/firms/z65/index.vue'),
    f66: () => import('@/components/firms/z66/index.vue'),
    f67: () => import('@/components/firms/z67/index.vue'),
    f68: () => import('@/components/firms/z68/index.vue'),
    f69: () => import('@/components/firms/z69/index.vue'),
    f70: () => import('@/components/firms/z70/index.vue'),
    f71: () => import('@/components/firms/z71/index.vue'),
    f72: () => import('@/components/firms/z72/index.vue'),
    f73: () => import('@/components/firms/z73/index.vue'),
    f74: () => import('@/components/firms/z74/index.vue'),
    f75: () => import('@/components/firms/z75/index.vue'),
    f76: () => import('@/components/firms/z76/index.vue'),
    f77: () => import('@/components/firms/z77/index.vue'),
    f78: () => import('@/components/firms/z78/index.vue'),
    f79: () => import('@/components/firms/z79/index.vue'),
    f80: () => import('@/components/firms/z80/index.vue'),
    f81: () => import('@/components/firms/z81/index.vue'),
    f82: () => import('@/components/firms/z82/index.vue'),
    f83: () => import('@/components/firms/z83/index.vue'),
    f84: () => import('@/components/firms/z84/index.vue'),
    f85: () => import('@/components/firms/z85/index.vue'),
    f86: () => import('@/components/firms/z86/index.vue'),
    f87: () => import('@/components/firms/z87/index.vue'),
    f88: () => import('@/components/firms/z88/index.vue'),
}

export const firmsList = [
    {
        img: gm("shoplogo/3.png"),
        name: "姹熻嫃鐪佸缓绛戠瀛︾爺绌堕櫌鏈夐檺鍏徃",
        active: "f0",
    },
    {
        img: gm("shoplogo/1.png"),
        name: "姹熻嫃姹熸捣鏉惂缁胯壊寤虹瓚绉戞妧鏈夐檺鍏徃",
        active: "f1",
    },
    {
        img: gm("shoplogo/2.png"),
        name: "姹熻嫃瀹滃畨寤鸿鏈夐檺鍏徃",
        active: "f6",
    },
    {
        img: gm("shoplogo/4.png"),
        name: "瀹忓ぇ寤鸿闆嗗洟鏈夐檺鍏徃",
        active: "f5",
    },
    {
        img: gm("shoplogo/5.png"),
        name: "鍗椾含璐濆攼寤虹瓚绉戞妧鏈夐檺鍏徃",
        active: "f11",
    },
    {
        img: gm("shoplogo/6.png"),
        name: "鑻忓窞浣冲浐澹柊鏉愭枡绉戞妧鏈夐檺鍏徃",
        active: "f7",
    },
    {
        img: gm("shoplogo/7.png"),
        name: "鍖椾含涓滄柟闆ㄨ櫣闃叉按鎶€鏈偂浠芥湁闄愬叕鍙",
        active: "f2",
    },

    {
        img: gm("shoplogo/9.png"),
        name: "姹熻嫃鎿庡ぉ宸ヤ笟浜掕仈缃戞湁闄愬叕鍙",
        active: "f3",
    },

    {
        img: gm("shoplogo/10.png"),
        name: "涓婃捣鍦ｅ濉戜笟鏈夐檺鍏徃",
        active: "f4",
    },
    {
        img: gm("shoplogo/11.png"),
        name: "涓嚎涓板缓璁鹃泦鍥㈣偂浠芥湁闄愬叕鍙",
        active: "f8",
    },
    {
        img: gm("shoplogo/12.png"),
        name: "姹熻嫃鎵缓闆嗗洟鏈夐檺鍏徃",
        active: "f9",
    },
    {
        img: gm("shoplogo/13.jpg"),
        name: "姹熻嫃閿︿笂寤虹瓚绉戞妧鏈夐檺鍏徃",
        active: "f10",
    },
    {
        img: gm("shoplogo/14.png"),
        name: "鑻忓窞鏌埄杈捐楗拌偂浠芥湁闄愬叕鍙",
        active: "f13",
    },
    {
        img: gm("shoplogo/15.png"),
        name: "涔呯摯绉戞妧",
        active: "f12",
    },
    {
        img: gm("shoplogo/16.png"),
        name: "姹熻嫃浜屽崄鍏害鏈哄櫒浜虹爺绌堕櫌鏈夐檺鍏徃",
        active: "f14",
    },
    {
        img: gm("shoplogo/17.png"),
        name: "鍥哄痉濞佹妧鏈偂浠芥湁闄愬叕鍙",
        active: "f15",
    },
    {
        img: gm("shoplogo/18.png"),
        name: "鍥界綉姹熻嫃",
        active: "f16",
    },
    {
        img: gm("shoplogo/19.png"),
        name: "姹熻嫃寤虹瓚鑱屼笟瀛﹂櫌",
        active: "f17",
    },
    {
        img: gm("shoplogo/20.png"),
        name: "姹熻嫃鏈楁棴鑺傝兘绉戞妧鏈夐檺鍏徃",
        active: "f18",
    },
    {
        img: gm("shoplogo/21.png"),
        name: "閲戝煍鍥灄",
        active: "f19",
    },
    {
        img: gm("shoplogo/22.png"),
        name: "鑹惧垪澶╁厓寤虹瓚鎶€鏈?姹熻嫃)鏈夐檺鍏徃",
        active: "f20",
    },
    {
        img: gm("shoplogo/23.png"),
        name: "鍔犳嬁澶V纭湪鍏徃",
        active: "f21",
    },
    {
        img: gm("shoplogo/24.png"),
        name: "璐濆姞鑹惧锛堜笂娴凤級寤虹瓚璁捐鍜ㄨ鏈夐檺鍏徃",
        active: "f22",
    },
    {
        img: gm("shoplogo/25.png"),
        name: "婀栧寳娆ц偗鐜绉戞妧鏈夐檺鍏徃",
        active: "f23",
    },
    {
        img: gm("shoplogo/26.png"),
        name: "鍔犳嬁澶у嚡椤垮浗闄呭叕鍙",
        active: "f24",
    },
    {
        img: gm("shoplogo/27.png"),
        name: "绉戞礇寰锋秱鏂",
        active: "f25",
    },
    {
        img: gm("shoplogo/28.png"),
        name: "鏋楀垱涓浗",
        active: "f26",
    },
    {
        img: gm("shoplogo/29.png"),
        name: "搴峰崥杈惧缓璁剧鎶€闆嗗洟",
        active: "f27",
    },
    {
        img: gm("shoplogo/31.png"),
        name: "姹熻嫃纰ф捣瀹夊叏鐜荤拑绉戞妧鑲′唤鏈夐檺鍏徃",
        active: "f29",
    },
    {
        img: gm("shoplogo/32.png"),
        name: "甯稿窞澶╃粡鏂板瀷寤烘潗鏈夐檺鍏徃",
        active: "f30",
    },
    {
        img: gm("shoplogo/33.png"),
        name: "涓囬偊寰仿锋爧姊侀摑涓氭湁闄愬叕鍙",
        active: "f31",
    },
    {
        img: gm("shoplogo/34.png"),
        name: "姹熻嫃鑻忔弗鑺傝兘绉戞妧鏈夐檺鍏徃",
        active: "f32",
    },
    {
        img: gm("shoplogo/35.jpeg"),
        name: "姹熼槾浜斿渤寤虹瓚鑺傝兘绉戞妧鏈夐檺鍏徃",
        active: "f33",
    },
    {
        img: gm("shoplogo/36.png"),
        name: "姹熻嫃鎹烽槼绉戞妧鑲′唤鏈夐檺鍏徃",
        active: "f34",
    },
    {
        img: gm("shoplogo/37.png"),
        name: "姹熻嫃閲戠櫨鍚堥棬绐楃鎶€鏈夐檺鍏徃",
        active: "f35",
    },
    {
        img: gm("shoplogo/38.png"),
        name: "鍗椾含鍚涗箰寤虹瓚鏂版潗鏂欐湁闄愬叕鍙",
        active: "f36",
    },
    {
        img: gm("shoplogo/39.png"),
        name: "姹熻嫃鍏嬫媺璧涘厠缁胯壊寤虹瓚浜т笟鍙戝睍鏈夐檺鍏徃",
        active: "f37",
    },
    // {
    //     img: gm("shoplogo/40.png"),
    //     name: "鍗楅€氭捣楣版湪涓氳偂浠芥湁闄愬叕鍙?,
    //     active: "f38",
    // },
    {
        img: gm("shoplogo/41.png"),
        name: "鏃犻敗鍒╂棩鑳芥簮绉戞妧鏈夐檺鍏徃",
        active: "f39",
    },
    //  {
    //     img: gm("shoplogo/42.png"),
    //     name: "鏃犻敗閼旱妯伄闃虫妧鏈湁闄愬叕鍙?,
    //     active: "f40",
    // },
    {
        img: gm("shoplogo/43.png"),
        name: "鍗楅€氶缚鐩涜楗板伐绋嬫湁闄愬叕鍙",
        active: "f41",
    },
    {
        img: gm("shoplogo/44.png"),
        name: "姹熻嫃鑻忛懌瑁呴グ锛堥泦鍥級鍏徃",
        active: "f42",
    },
    {
        img: gm("shoplogo/45.png"),
        name: "姹熻嫃鎭掍俊璇洪噾绉戞妧鑲′唤鏈夐檺鍏徃",
        active: "f43",
    },
    {
        img: gm("shoplogo/46.png"),
        name: "姹熻嫃娲佹鼎绠′笟鏈夐檺鍏徃",
        active: "f44",
    },
    {
        img: gm("shoplogo/47.jpg"),
        name: "姹熻嫃灞辩敱甯濆ゥ鑺傝兘鏂版潗鑲′唤鏈夐檺鍏徃",
        link: "https://mp.weixin.qq.com/s/fOiNPWGT17qF1_EWwjVwjA"
    },
    {
        name: "姹熻嫃鍩庝埂寤鸿鑱屼笟瀛﹂櫌",
        active: "f45",
    },
    {
        name: "姹熻嫃鐪佽鍒掕璁￠泦鍥㈡湁闄愬叕鍙",
        active: "f46",
    },
    {
        img: gm("shoplogo/48.png"),
        name: "寰峰浗鎬濆笗",
        active: "f47",
    },
    {
        img: gm("shoplogo/49.png"),
        name: "鑻忓窞甯傚缓绛戠瀛︾爺绌堕櫌闆嗗洟鑲′唤鏈夐檺鍏徃",
        active: "f48",
    },
    {
        img: gm("shoplogo/50.jpeg"),
        name: "鑻忓窞鏂颁竴閫犱环甯堜环鏍间簨鍔℃墍鏈夐檺鍏徃",
        active: "f49",
    },
    {
        img: gm("shoplogo/51.png"),
        name: "鑻忓窞鍥灄璁捐闄㈣偂浠芥湁闄愬叕鍙",
        active: "f50",
    },
    {
        img: gm("shoplogo/52.jpg"),
        name: "娉板北鐜荤拑绾ょ淮鏈夐檺鍏徃",
        active: "f51",
    },
    {
        img: gm("shoplogo/53.png"),
        name: "鍗椾含澶╁姞鐜绉戞妧鏈夐檺鍏徃",
        active: "f52",
    },
    {
        img: gm("shoplogo/54.png"),
        name: "姹熻嫃鍚岀洓鐜繚鎶€鏈湁闄愬叕鍙",
        active: "f53",
    },
    {
        img: gm("shoplogo/55.png"),
        name: "浜旇璇洪亾",
        active: "f54",
    },
    {
        img: gm("shoplogo/56.png"),
        name: "鏂板崕鐩涜妭鑳界鎶€鑲′唤鏈夐檺鍏徃",
        active: "f55",
    },
    {
        img: gm("shoplogo/57.png"),
        name: "姹熻嫃鏂扮泩瑁呴厤寤虹瓚绉戞妧鏈夐檺鍏徃",
        active: "f56",
    },
    {
        img: gm("shoplogo/58.png"),
        name: "寰愬窞宸ョ▼鏈烘闆嗗洟鏈夐檺鍏徃",
        active: "f57",
    },
    {
        img: gm("shoplogo/59.png"),
        name: "姹熻嫃鎵缓闆嗗洟鏈夐檺鍏徃",
        active: "f58",
    },
    {
        img: gm("shoplogo/60.png"),
        name: "鑻辫揪绉戞妧闆嗗洟",
        active: "f59",
    },
    {
        img: gm("shoplogo/61.png"),
        name: "姘歌嚮绉戞妧鑲′唤鏈夐檺鍏徃",
        active: "f60",
    },
    {
        img: gm("shoplogo/62.png"),
        name: "杩滃ぇ鑳芥簮鍒╃敤绠＄悊鏈夐檺鍏徃",
        active: "f61",
    },
    {
        img: gm("shoplogo/63.png"),
        name: "闀囨睙缁垮缓宸ョ▼鍜ㄨ鏈夐檺鍏徃",
        active: "f62",
    },
    {
        img: gm("shoplogo/64.jpg"),
        name: "涓缓鍏眬鏂囨梾",
        active: "f63",
    },
    {
        img: gm("shoplogo/65.png"),
        name: "涓缓浜斿眬绗竴寤鸿鏈夐檺鍏徃",
        active: "f64",
    },
    {
        img: gm("shoplogo/66.png"),
        name: "涓搧涓婃捣灞€",
        active: "f65",
    },
    {
        img: gm("shoplogo/67.jpeg"),
        name: "涓搧涓冨眬闆嗗洟鏈夐檺鍏徃",
        active: "f66",
    },
    {
        img: gm("shoplogo/68.jpg"),
        name: "涓叴閫氳",
        active: "f67",
    },
    {
        img: gm("shoplogo/69.png"),
        name: "姹熻嫃绛戞．寤虹瓚璁捐鏈夐檺鍏徃",
        active: "f68",
    },
    {
        img: gm("shoplogo/70.png"),
        name: "甯稿窞甯傚缓绛戠瀛︾爺绌堕櫌闆嗗洟鑲′唤鏈夐檺鍏徃",
        active: "f69",
    },
    {
        img: gm("shoplogo/71.png"),
        name: "涓滃崡澶у寤虹瓚璁捐鐮旂┒闄㈡湁闄愬叕鍙",
        active: "f70",
    },
    {
        img: gm("shoplogo/72.png"),
        name: "鏅烘嘲鏂拌兘婧愶紙涓滃彴锛夋湁闄愬叕鍙?",
        active: "f71",
    },
    {
        img: gm("shoplogo/73.png"),
        name: "鏌埄杈?",
        active: "f72",
    },
    {
        img: gm("shoplogo/74.png"),
        name: "姹熻嫃榫欒吘宸ョ▼璁捐鑲′唤鏈夐檺鍏徃 ",
        active: "f73",
    },
    {
        img: gm("shoplogo/75.png"),
        name: "鍗椾含閲戝寤虹瓚璁捐鏈夐檺鍏徃 ",
        active: "f74",
    },
    {
        img: gm("shoplogo/76.png"),
        name: "甯稿窞浜氱帥椤胯偂浠芥湁闄愬叕鍙?",
        active: "f75",
    },
    {
        img: gm("shoplogo/77.png"),
        name: "浜戠巹鎶€鏈?娣卞湷)鏈夐檺鍏徃 ",
        active: "f76",
    },
    {
        img: gm("shoplogo/8.png"),
        name: "鍗椾含闀挎睙閮藉競寤虹瓚璁捐鑲′唤鏈夐檺鍏徃",
        active: "f77",
    },
    {
        img: gm("shoplogo/78.png"),
        name: "涓缓鍏眬绗笁寤鸿鏈夐檺鍏徃",
        active: "f78",
    },
    {
        img: gm("shoplogo/79.jpeg"),
        name: "SGS",
        active: "f79",
    },
    {
        img: gm("shoplogo/80.png"),
        name: "鍗椾含宸ヤ笟澶у",
        active: "f80",
    },
    {
        img: gm("shoplogo/64.jpg"),
        name: "涓缓浜屽眬绗笁寤虹瓚宸ョ▼鏈夐檺鍏徃",
        active: "f81",
    },
    {
        img: gm("shoplogo/81.png"),
        name: "鑻忓窞缇庡皵閭︾撼绫虫潗鏂欐湁闄愬叕鍙",
        active: "f82",
    },
    {
        img: gm("shoplogo/82.png"),
        name: "涓浗寤鸿閾惰姹熻嫃鐪佸垎琛",
        active: "f83",
    },
    {
        img: gm("shoplogo/83.png"),
        name: "鍗椾含閾惰鑲′唤鏈夐檺鍏徃",
        active: "f84",
    },
  
    {
        img: gm("shoplogo/84.jpg"),
        name: "娴﹀彂閾惰",
        active: "f85",
    },
    {
        img: gm("shoplogo/85.jpg"),
        name: "涓浗浜烘皯璐骇淇濋櫓鑲′唤鏈夐檺鍏徃姹熻嫃鐪佸垎鍏徃",
        active: "f86",
    },
    {
        img: gm("shoplogo/86.jpg"),
        name: "涓浗涓俊闆嗗洟鏈夐檺鍏徃",
        active: "f87",
    },
    {
        img: gm("shoplogo/87.png"),
        name: "绱噾璐骇淇濋櫓鑲′唤鏈夐檺鍏徃",
        active: "f88",
    },
        {
        img: gm("shoplogo/88.png"),
        name: "鍗冩€濇澘鍥介檯鍏徃",
        active: "f89",
    }
]


export const homeNewList = [
    {
        timer: "2025-04-08",        title: i18n.t("newIndex.line11"),
        subtitle: i18n.t(""),
        img: gm("2025-01.jpg"),
        link: "https://mp.weixin.qq.com/s/g4DUfx84ZCcpvD-9p9bwCg"
    },
    {
        timer: "2025-04-07",        title: i18n.t("newIndex.line12"),
        subtitle: i18n.t(""),
        img: gm("2025-02.jpg"),
        link: "https://mp.weixin.qq.com/s/OEkCtAtLY7lItQ4IKHfZIg"
    },
    {
        timer: "2025-04-04",        title: i18n.t("newIndex.line13"),
        subtitle: i18n.t(""),
        img: gm("2025-03.jpg"),
        link: "https://mp.weixin.qq.com/s/FOKg9UC08w87fwnBX8Id2g"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line14"),
        subtitle: i18n.t(""),
        img: gm("2025-04.jpg"),
        link: "https://mp.weixin.qq.com/s/YpmHlwP_Yzq4gMesuHC_HA"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line15"),
        subtitle: i18n.t(""),
        img: gm("2025-05.jpg"),
        link: "https://mp.weixin.qq.com/s/q4nwg2IsP8nXXawItOfXjw"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line16"),
        subtitle: i18n.t(""),
        img: gm("2025-06.jpg"),
        link: "https://mp.weixin.qq.com/s/F09wRaZmVHAORbZwNXOUuQ"
    },
    {
        timer: "2025-04-02",        title: i18n.t("newIndex.line17"),
        subtitle: i18n.t(""),
        img: gm("2025-07.jpg"),
        link: "https://mp.weixin.qq.com/s/zN_vOtQpaQrCncAUqssVyQ"
    },
    {
        timer: "2025-04-01",        title: i18n.t("newIndex.line18"),
        subtitle: i18n.t(""),
        img: gm("2025-08.jpg"),
        link: "https://mp.weixin.qq.com/s/trCYFQkQfItdTLI-9Yfqow"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line19"),
        subtitle: i18n.t(""),
        img: gm("2025-09.jpg"),
        link: "https://mp.weixin.qq.com/s/2-uU6R8UE4_zRcqB_9dfuw"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line20"),
        subtitle: i18n.t(""),
        img: gm("2025-10.jpg"),
        link: "https://mp.weixin.qq.com/s/sn4YJAdCLWxblzdNAKE2IA"
    },
    {
        timer: "2025-03-28",        title: i18n.t("newIndex.line21"),
        subtitle: i18n.t(""),
        img: gm("2025-11.jpg"),
        link: "https://mp.weixin.qq.com/s/9YaunTeZDTLbdc0vLjt6WQ"
    },
    {
        timer: "2025-03-27",        title: i18n.t("newIndex.line22"),
        subtitle: i18n.t(""),
        img: gm("2025-12.jpg"),
        link: "https://mp.weixin.qq.com/s/1U0sgUp4bWiIk7WAm_nsmw"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line23"),
        subtitle: i18n.t(""),
        img: gm("2025-13.jpg"),
        link: "https://mp.weixin.qq.com/s/EF1ED04tAMpKguSExZly4w"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line24"),
        subtitle: i18n.t(""),
        img: gm("2025-14.jpg"),
        link: "https://mp.weixin.qq.com/s/JETBmlZoY9iGGefEUQ9C-w"
    },
    {
        timer: "2025-03-22",        title: i18n.t("newIndex.line25"),
        subtitle: i18n.t(""),
        img: gm("2025-15.jpg"),
        link: "https://mp.weixin.qq.com/s/zKQ69QKjzhihFMMcGE1zsg"
    },
    {
        timer: "2025-03-30",        title: i18n.t("newIndex.line26"),
        subtitle: i18n.t(""),
        img: gm("2025-16.jpg"),
        link: "https://mp.weixin.qq.com/s/vw13-mRpWwa8Ve8MmGI3DQ"
    },
    {
        timer: "2025-03-29",        title: i18n.t("newIndex.line27"),
        subtitle: i18n.t(""),
        img: gm("2025-17.jpg"),
        link: "https://mp.weixin.qq.com/s/5K5FCaaLozDCke64KxL15g"
    },
    {
        timer: "2025-03-26",        title: i18n.t("newIndex.line28"),
        subtitle: i18n.t(""),
        img: gm("2025-18.jpg"),
        link: "https://mp.weixin.qq.com/s/QNkJQi-kGD_RH4bArefswQ"
    },
    {
        timer: "2025-03-07",        title: i18n.t("newIndex.line29"),
        subtitle: i18n.t(""),
        img: gm("2025-19.jpg"),
        link: "https://mp.weixin.qq.com/s/ljD8_h9ruO0rIKCyKTLDig"
    },
    {
        timer: "2025-02-14",        title: i18n.t("newIndex.line30"),
        subtitle: i18n.t(""),
        img: gm("2025-20.jpg"),
        link: "https://mp.weixin.qq.com/s/00fmP1caNOnhYzrg9VL3Uw"
    },
    {
        timer: "2024-12-05",        title: i18n.t("newIndex.line31"),
        subtitle: i18n.t(""),
        img: gm("2025-21.jpg"),
        link: "https://mp.weixin.qq.com/s/RnDYDqAVQBmCwtqA60C_Fw"
    },
    {
        timer: "2024-12-24",        title: i18n.t("newIndex.line32"),
        subtitle: i18n.t(""),
        img: gm("2025-22.jpg"),
        link: "https://mp.weixin.qq.com/s/ALTJrSN938yj8S2cGRv2jQ"
    },
    {
        timer: "2024-12-26",        title: i18n.t("newIndex.line33"),
        subtitle: i18n.t(""),
        img: gm("2025-23.jpg"),
        link: "https://mp.weixin.qq.com/s/f7gpQTTpvMt6TDJpAFJDrA"
    },
    {
        timer: "2024-12-27",        title: i18n.t("newIndex.line34"),
        subtitle: i18n.t(""),
        img: gm("2025-24.jpg"),
        link: "https://mp.weixin.qq.com/s/CqT11yl5la8LlXcIbHML-w"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line1"),
        title: i18n.t("newIndex.line2"),
        img: gm("1-2.png"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-08-10",        title: i18n.t("newIndex.line3"),
        title: i18n.t("newIndex.line4"),
        img: gm("1-3.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-08-18",        title: i18n.t("newIndex.line5"),
        title: i18n.t("newIndex.line6"),
        img: gm("1-4.jpg"),
        link: "https://mp.weixin.qq.com/s/sg_m1zSGWARpQcB3yeLcbg"
    },
    {
        timer: "2023-09-21",        title: i18n.t("newIndex.line35"),
        subtitle: i18n.t(""),
        img: gm("2023-01.jpg"),
        link: "https://mp.weixin.qq.com/s/d-RfUGKnop9EhbzXRvoA9Q"
    },
    {
        timer: "2023-09-26",        title: i18n.t("newIndex.line36"),
        subtitle: i18n.t(""),
        img: gm("2023-02.jpg"),
        link: "https://mp.weixin.qq.com/s/MDY0rH1Sl1mIBwFuyMl3Yw"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line37"),
        subtitle: i18n.t(""),
        img: gm("2023-03.jpg"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-09-16",        title: i18n.t("newIndex.line38"),
        subtitle: i18n.t(""),
        img: gm("2023-04.jpg"),
        link: "https://mp.weixin.qq.com/s/QwORfSUjcBTj4rvgqFDsSw"
    },
    {
        timer: "2023-10-10",        title: i18n.t("newIndex.line39"),
        subtitle: i18n.t(""),
        img: gm("2023-05.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-10-12",        title: i18n.t("newIndex.line40"),
        subtitle: i18n.t(""),
        img: gm("2023-06.jpg"),
        link: "https://mp.weixin.qq.com/s/cOSmSLpqPwRMgqY7qgDlYA"
    },
    {
        timer: "2023-08-02",        title: i18n.t("newIndex.line41"),
        subtitle: i18n.t(""),
        img: gm("2023-07.jpg"),
        link: "https://mp.weixin.qq.com/s/MPDzTqxTpbnw1EHoh9sDAw"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line42"),
        subtitle: i18n.t(""),
        img: gm("2023-08.jpg"),
        link: "https://mp.weixin.qq.com/s/z-RCuO1KjKSGqo91AgFOcQ"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line43"),
        subtitle: i18n.t(""),
        img: gm("2023-09.jpg"),
        link: "https://mp.weixin.qq.com/s/iw70GyvQ3WsNnyKD2Yr_SA"
    },
    {
        timer: "2023-10-13",        title: i18n.t("newIndex.line44"),
        subtitle: i18n.t(""),
        img: gm("2023-10.jpg"),
        link: "https://mp.weixin.qq.com/s/oA4gXpbv7lC8r0jlDsJTrQ"
    },
    {
        timer: "2023-10-14",        title: i18n.t("newIndex.line45"),
        subtitle: i18n.t(""),
        img: gm("2023-11.jpg"),
        link: "https://mp.weixin.qq.com/s/02nvHTWWb0ttASZy4QMeIQ"
    }
]


